import React, { Component, Fragment } from "react";
import Async from "react-select";
import modalIcon from "../../../assets/images/testIcon.svg";
import autosize from "autosize";
import Field from "../../Common/Field/Field";
import ModuleHeader from "../ModuleHeader";
import Button from "../../Buttons/Button";
import ButtonIcon from "../../Costing/Button/ButtonIcon";
import "./index.css";
import Draft from './draft'
import { element } from "prop-types";
export default class GarmentTechModule extends Component {
  state = {
    _id: "",
    garmentTechnologist: null,
    // frag: null,
    STATUS: [],
    sampleDate: null,
    assignedToList: [],
    disabled: false
  };

  componentWillMount() {
    // .then(response => {
    //   // let sample= this.state.sampleForm
    // // if (!sample.garmentTechnologist.sampleForm.fitMesurements || sample.garmentTechnologist.sampleForm.fitMesurements === "")
    // //         sample.garmentTechnologist.sampleForm.fitMesurements =
    // //           response.text.data.OTHERS.sampleForm.fitMesurements
    // })

    const {
      _id,
      garmentTechnologist,
      STATUS,
      disabled,
      // frag,
      assignedToList,
      garmentProcess
    } = this.props;
    this.setState({
      _id,
      garmentTechnologist,
      garmentProcess,
      // frag,
      STATUS,
      disabled,
      assignedToList
    });


  }



  onEditorStateChange = (value, arrKey, arrSubKey) => {
    console.log(value, '--------------------value', arrKey, arrSubKey)
    // let frag=this.state.garmentTechnologist.sampleForm;
    // if(!frag.fitMesurements.comments || frag.fitMesurements.comments ===""){
    //   console.log('empty****',frag);

    // }
    // this.setState ({
    //   frag
    // })
    // let sampleRequest = { ...this.state.sampleRequest };
    // console.log(JSON.stringify(sampleRequest)+'----sampleRequest---')
    // sampleRequest.garmentTechnologist.sampleForm[arrKey][i]['comments']=value
    // this.setState ({
    //   // sampleRequest
    //   texteditordraft : value
    // })
    this.props.editorDraft(value, arrKey, arrSubKey)
  }

  componentWillReceiveProps(nextProps) {
    const {
      _id,
      garmentTechnologist,
      STATUS,
      disabled,
      assignedToList,
      garmentProcess
    } = nextProps;
    this.setState({
      _id,
      garmentTechnologist,
      garmentProcess,
      STATUS,
      disabled,
      assignedToList
    });
  }

  render() {

    const { permissions } = this.props;
    const { garmentTechnologist, STATUS, sampleDate } = this.state;

    autosize(document.querySelectorAll("textarea"));

    return (

      <div
        className="card-filter meeting-min-con"
        id="garmentTechnologist"
        style={{ marginBottom: ".5%" }}
      >
        <div className="col-md-12">
          <ModuleHeader
            header={"GARMENT TECHNOLOGIST"}
            moduleName={"garmentTechnologist"}
            updateModulesMain={this.props.updateModulesMain}
            process={this.state.garmentProcess}
            onClick={this.onOpenModal}
            statusList={STATUS}
            _id={this.state._id}
            disabled={this.state.disabled}
          />

          <div className="p-1 col-md-2">
            <Field
              // durationETA={this.props.durationETA}
              isFormGroup={true}
              inputType="date"
              inputName="sampleDate"
              value={garmentTechnologist.sampleDate}

              label={"Sample Date"}
              onChange={this.props.updateGarment}
              onChange={(name, value) =>
                this.props.updateGarment(name, value)
              }
              disabled={this.state.disabled}
            />
          </div>
          <div
            className="col-md-12 product-form"
            style={{ paddingBottom: "1%" }}
            id="garmentForm"
          >
            <form name="garmentForm" id="garmentForm2">
              <div className="col-md-12 no-padding mt-2">
                <span className="text-center">
                  <h6>
                    <b>SAMPLE RELEASE FORM</b>
                    <span
                      className="printer pull-right cursor-hover"
                      onClick={() => this.props.printGarment("print-garment")}
                    >
                      <a>
                        <i className="fa fa-print" /> Print
                      </a>
                    </span>
                  </h6>
                </span>
                <div className="srf-container">
                  <div className="table-container">
                    <table className="manage_permissions garment-tech-table">
                      <thead>
                        <tr>
                          <th data-field="comment">
                            Comments recieved from buyer
                          </th>
                          <th data-field="fab">Fab.</th>
                          <th data-field="trim">Trims</th>
                          <th data-field="work">Workmanship</th>
                          <th data-field="change">Buyer's changes</th>
                          <th data-field="pat">Pat.</th>
                          <th data-field="remark">Remarks</th>
                          {/* <th>
                            {!this.state.disabled &&
                              (permissions.create || permissions.edit) && (
                                <ButtonIcon
                                  buttonType="add"
                                  addRemoveFunc={() =>
                                    this.props.addGarmentForm()
                                  }
                                />
                              )}
                          </th> */}
                        </tr>
                      </thead>

                      <tbody>
                        <tr className="mod-header">
                          <th
                            style={{
                              textAlign: "left"
                            }}
                          >
                            Fit / MEASUREMENTS Comments
                          </th>
                          <th colSpan="7" >
                            {!this.state.disabled &&
                              (permissions.create || permissions.edit) && (
                                <ButtonIcon
                                  buttonType="add"
                                  addRemoveFunc={() =>
                                    this.props.addGarmentForm('fitMesurements')
                                  }

                                />
                              )}
                          </th>
                        </tr>
                        {/* {Object.keys(this.state.sampleRequest.garmentTechnologist.sampleForm).map((sampleForm,i) => (

                      //  )) */}
                        {garmentTechnologist.sampleForm.fitMesurements.length ? garmentTechnologist.sampleForm.fitMesurements.map((sampleForm, i) => (
                          <tr key={'gar' + i}>
                            <td width="50%">
                              <Draft
                                value={sampleForm.comments}
                                editorText={this.onEditorStateChange}
                                editorType='fitMesurements'
                                editorSubType={`fitMesurements${i}`}
                              />

                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"fab" + 'fitMesurements' + i}
                                value={sampleForm.fab}
                                // label="Marker Requirement"
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm("fab", 'fitMesurements', value, i)
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"trims" + 'fitMesurements' + i}
                                value={sampleForm.trims}
                                // label="Marker Requirement"
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(
                                    "trims",
                                    'fitMesurements',
                                    value,
                                    i
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"workManShip" + 'fitMesurements' + i}
                                value={sampleForm.workManShip}
                                // label="Marker Requirement"
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(
                                    "workManShip",
                                    'fitMesurements',
                                    value,
                                    i
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"buyerChanges" + 'fitMesurements' + i}
                                value={sampleForm.buyerChanges}
                                // label="Marker Requirement"
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(
                                    "buyerChanges",
                                    'fitMesurements',
                                    value,
                                    i
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"pat" + 'fitMesurements' + i}
                                value={sampleForm.pat}
                                // label="Marker Requirement"
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm("pat", 'fitMesurements', value, i)
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td
                              style={{
                                width: "25%"
                              }}
                            >
                              <Field
                                inputType="textarea"
                                inputName="remarks"
                                value={sampleForm.remarks}
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(name, 'fitMesurements', value, i)
                                }
                                className="remarks"
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              {!this.state.disabled &&
                                (permissions.create || permissions.edit) && (
                                  <ButtonIcon
                                    buttonType="clear"
                                    addRemoveFunc={() =>
                                      this.props.removeGarmentForm('fitMesurements', i)
                                    }
                                  />
                                )}
                            </td>
                          </tr>

                        )) : ''}
                        <tr className="mod-header">
                          <th
                            style={{
                              textAlign: "left"
                            }}
                          >
                            MAKE UP / CONSTRUCTION:

                          </th>
                          <th colSpan="7" >
                            <ButtonIcon
                              buttonType="add"
                              addRemoveFunc={() =>
                                this.props.addGarmentForm('makeupConstruction')
                              }
                            />
                          </th>
                        </tr>

                        {garmentTechnologist.sampleForm.makeupConstruction.length ? garmentTechnologist.sampleForm.makeupConstruction.map((sampleForm, i) => (
                          <tr key={i}>
                            <td>
                              <Draft
                                value={sampleForm.comments}
                                editorText={this.onEditorStateChange}
                                editorType='makeupConstruction'
                                editorSubType={`makeupConstruction${i}`}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"fab" + 'makeupConstruction' + i}
                                value={sampleForm.fab}
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm("fab", 'makeupConstruction', value, i)
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"trims" + 'makeupConstruction' + i}
                                value={sampleForm.trims}
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(
                                    "trims",
                                    'makeupConstruction',
                                    value,
                                    i
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"workManShip" + 'makeupConstruction' + i}
                                value={sampleForm.workManShip}
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(
                                    "workManShip",
                                    'makeupConstruction',
                                    value,
                                    i
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"buyerChanges" + 'makeupConstruction' + i}
                                value={sampleForm.buyerChanges}
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(
                                    "buyerChanges",
                                    'makeupConstruction',
                                    value,
                                    i
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"pat" + 'makeupConstruction' + i}
                                value={sampleForm.pat}
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm("pat", 'makeupConstruction', value, i)
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td
                              style={{
                                width: "25%"
                              }}
                            >
                              <Field
                                inputType="textarea"
                                inputName="remarks"
                                value={sampleForm.remarks}
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(name, 'makeupConstruction', value, i)
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              {!this.state.disabled &&
                                (permissions.create || permissions.edit) && (
                                  <ButtonIcon
                                    buttonType="clear"
                                    addRemoveFunc={() =>
                                      this.props.removeGarmentForm('makeupConstruction', i)
                                    }
                                  />
                                )}
                            </td>
                          </tr>

                        )) : ''}
                        <tr className="mod-header">
                          <th
                            style={{
                              textAlign: "left"
                            }}
                          >
                            TRIMS / COMPONENTS :
                          </th>
                          <th colSpan="7" >
                            <ButtonIcon
                              buttonType="add"
                              addRemoveFunc={() =>
                                this.props.addGarmentForm('trimsComponents')
                              }
                            />
                          </th>
                        </tr>
                        {garmentTechnologist.sampleForm.trimsComponents.length ? garmentTechnologist.sampleForm.trimsComponents.map((sampleForm, i) => (
                          <tr key={i}>
                            <td>

                              <Draft
                                // inputType="textarea" inputName="comments"
                                value={sampleForm.comments}
                                // onEditorStateChange = {this.onEditorStateChange('trimsComponents', i)}
                                editorText={this.onEditorStateChange}
                                editorType='trimsComponents'
                                editorSubType={`trimsComponents${i}`}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"fab" + 'trimsComponents' + i}
                                value={sampleForm.fab}
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm("fab", 'trimsComponents', value, i)
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"trims" + 'trimsComponents' + i}
                                value={sampleForm.trims}
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(
                                    "trims",
                                    'trimsComponents',
                                    value,
                                    i
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"workManShip" + 'trimsComponents' + i}
                                value={sampleForm.workManShip}
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(
                                    "workManShip",
                                    'trimsComponents',
                                    value,
                                    i
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"buyerChanges" + 'trimsComponents' + i}
                                value={sampleForm.buyerChanges}
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(
                                    "buyerChanges",
                                    'trimsComponents',
                                    value,
                                    i
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                inputType="checkbox"
                                inputName={"pat" + 'trimsComponents' + i}
                                value={sampleForm.pat}
                                className=""
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm("pat", 'trimsComponents', value, i)
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td
                              style={{
                                width: "25%"
                              }}
                            >
                              <Field
                                inputType="textarea"
                                inputName="remarks"
                                value={sampleForm.remarks}
                                onChange={(name, value) =>
                                  this.props.updateGarmentForm(name, 'trimsComponents', value, i)
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              {!this.state.disabled &&
                                (permissions.create || permissions.edit) && (
                                  <ButtonIcon
                                    buttonType="clear"
                                    addRemoveFunc={() =>
                                      this.props.removeGarmentForm('trimsComponents', i)
                                    }
                                  />
                                )}
                            </td>
                          </tr>

                        )) : ''}
                        <tr className="mod-header">
                          <th
                            style={{
                              textAlign: "left"
                            }}
                          >
                            PACKAGING / PRESENTATION :
                          </th>
                          <th colSpan="7" >
                            <ButtonIcon
                              buttonType="add"
                              addRemoveFunc={() =>
                                this.props.addGarmentForm('packPresentation')
                              }
                            />
                          </th>
                        </tr>
                        {
                          garmentTechnologist.sampleForm.packPresentation.map((sampleForm, i) => (
                            <tr key={i}>
                              <td>

                                <Draft
                                  // inputType="textarea" inputName="comments"
                                  value={sampleForm.comments}
                                  // onEditorStateChange = {this.onEditorStateChange('packPresentation', i)}
                                  editorText={this.onEditorStateChange}
                                  editorType='packPresentation'
                                  editorSubType={`packPresentation${i}`}
                                />


                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="checkbox"
                                  inputName={"fab" + 'packPresentation' + i}
                                  value={sampleForm.fab}
                                  className=""
                                  onChange={(name, value) =>
                                    this.props.updateGarmentForm("fab", 'packPresentation', value, i)
                                  }
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="checkbox"
                                  inputName={"trims" + 'packPresentation' + i}
                                  value={sampleForm.trims}
                                  className=""
                                  onChange={(name, value) =>
                                    this.props.updateGarmentForm(
                                      "trims",
                                      'packPresentation',
                                      value,
                                      i
                                    )
                                  }
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="checkbox"
                                  inputName={"workManShip" + 'packPresentation' + i}
                                  value={sampleForm.workManShip}
                                  className=""
                                  onChange={(name, value) =>
                                    this.props.updateGarmentForm(
                                      "workManShip",
                                      'packPresentation',
                                      value,
                                      i
                                    )
                                  }
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="checkbox"
                                  inputName={"buyerChanges" + 'packPresentation' + i}
                                  value={sampleForm.buyerChanges}
                                  className=""
                                  onChange={(name, value) =>
                                    this.props.updateGarmentForm(
                                      "buyerChanges",
                                      'packPresentation',
                                      value,
                                      i
                                    )
                                  }
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="checkbox"
                                  inputName={"pat" + 'packPresentation' + i}
                                  value={sampleForm.pat}
                                  className=""
                                  onChange={(name, value) =>
                                    this.props.updateGarmentForm("pat", 'packPresentation', value, i)
                                  }
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td
                                style={{
                                  width: "25%"
                                }}
                              >
                                <Field
                                  inputType="textarea"
                                  inputName="remarks"
                                  value={sampleForm.remarks}
                                  onChange={(name, value) =>
                                    this.props.updateGarmentForm(name, 'packPresentation', value, i)
                                  }
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                {!this.state.disabled &&
                                  (permissions.create || permissions.edit) && (
                                    <ButtonIcon
                                      buttonType="clear"
                                      addRemoveFunc={() =>
                                        this.props.removeGarmentForm('packPresentation', i)
                                      }
                                    />
                                  )}
                              </td>
                            </tr>

                          ))
                          // :''
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div className="col-md-12 no-padding comments-wrapper">
                <div className="col-md-12 no-padding step-one">
                  <Field
                    isFormGroup={true}
                    inputType="textarea"
                    inputName="garmentTechComments"
                    value={garmentTechnologist.garmentTechComments}
                    label="Garment Tech Comments"
                    onChange={this.props.updateGarment}
                    disabled={this.state.disabled}
                  />
                </div>
                <div className="col-md-11 mx-auto no-padding">
                  <div className="col-md-2 step-one">
                    <Field
                      isFormGroup={true}
                      inputType="checkboxToggle"
                      inputName="markerRequirements"
                      value={garmentTechnologist.markerRequirements}
                      label="Marker Requirement"
                      className=""
                      onChange={this.props.updateGarment}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div className="col-md-2 step-one">
                    <Field
                      isFormGroup={true}
                      inputType="checkboxToggle"
                      inputName="smvAmmendment"
                      value={garmentTechnologist.smvAmmendment}
                      label="SMV Ammendment"
                      className=""
                      onChange={this.props.updateGarment}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div className="col-md-2 step-one">
                    <Field
                      isFormGroup={true}
                      inputType="checkboxToggle"
                      inputName="tiIssues"
                      value={garmentTechnologist.tiIssues}
                      label="Technical Issues"
                      className=""
                      onChange={this.props.updateGarment}
                      disabled={this.state.disabled}
                    />
                  </div>

                  <div className="col-md-2 step-one">
                    <Field
                      isFormGroup={true}
                      inputType="checkboxToggle"
                      inputName="trailRequired"
                      value={garmentTechnologist.trailRequired}
                      label="Trail Required?"
                      className=""
                      onChange={this.props.updateGarment}
                      disabled={this.state.disabled}
                    />
                  </div>
                  <div className="col-md-2 step-one">
                    <Field
                      isFormGroup={true}
                      inputType="checkboxToggle"
                      inputName="mock"
                      value={garmentTechnologist.mock}
                      label="Mock"
                      className=""
                      onChange={this.props.updateGarment}
                      disabled={this.state.disabled}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-12 nopadding">
                <Field
                  isFormGroup={true}
                  inputType="textarea"
                  inputName="comment"
                  value={garmentTechnologist.comment}
                  label="comments"
                  onChange={this.props.updateGarment}
                  disabled={this.state.disabled}
                />
              </div>
            </form>
            {!this.state.disabled && (permissions.create || permissions.edit) && (
              <div className="col-md-12 no-padding text-center profile-btn">
                <Button
                  buttonName={"save"}
                  onClick={e => this.props.createGarment(e)}
                />
                <Button
                  buttonName={"Complete"}
                  onClick={e => this.props.completeGarment(e)}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SampleRequest/GarmentTechModule/index.js